/* eslint-disable no-console */
import React from 'react';
import { useMutation } from '@tanstack/react-query';
import { Button, useShowMessage } from '../../core-ui';

import { useFetchJson } from '../../support/useFetch';
import { safeInvokeAsync } from '../../core/support/safeInvokeAsync';

type Account = { id: string; name: string };

export function ManualPaymentExportButton(props: { accounts: Array<Account> }) {
  const { accounts } = props;
  const fetchJson = useFetchJson();
  const showMessage = useShowMessage();
  const { mutate: doSync, isLoading } = useMutation(
    async () => {
      showMessage(
        'success',
        t('Exporting manual payments. Check console for details.', {
          count: accounts.length,
        }),
      );
      const [data, error] = await safeInvokeAsync(() =>
        fetchJson(`/api/manual-payments/sync`),
      );
      if (error) {
        console.log('Error exporting manual payments');
        console.error(error);
      } else {
        console.log(data);
      }
    },
    {
      onSuccess: () => {
        showMessage('success', t('Exported successfully'));
      },
      onError: (error) => {
        console.error(error);
        showMessage('error', t('Error exporting: {error}', { error }));
      },
    },
  );

  if (!accounts.length) {
    return null;
  }

  return (
    <Button isLoading={isLoading} onClick={() => doSync()}>
      {t('Export Manual Payments')}
    </Button>
  );
}
